import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { useAuth } from "context/authContext";
import { Navigate } from "react-router-dom";
type Props = {
  children: React.ReactNode;
};

export const AuthLayout = (props: Props) => {
  const { currentUser } = useAuth();
  // add condition to check if currentUser is null, then redirect to login page
  if (currentUser) {
    return <Navigate to="/" />;
  }
  const { children } = props;
  return (
    <React.Fragment>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        sx={{
          backgroundColor: "#233F91",
          borderRadius: { xs: "0px 0px 32px 32px", md: "0px" },
          minHeight: { sm: "100vh", md: "100vh" },
        }}
      >
        <Box
          sx={{
            width: "100%",
            padding: { sm: "0px", md: "16px 40px" },
          }}
        >
          <Grid
            container
            spacing={{ xs: 10, md: 2 }}
            sx={{
              marginTop: { xs: "30px", md: "0px" },
            }}
          >
            <Grid
              item
              xs={12}
              sm={7.4}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Grid container direction="column" alignItems="center">
                <Grid item>
                  <Box
                    component="img"
                    src="assets/icons/affektilogo.png"
                    alt="logo"
                    sx={{
                      width: { xs: "112px", md: "272px" },
                      height: { xs: "44.21px", md: "107.37px" },
                    }}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    fontSize={{ xs: "6.95px", md: "16.89px" }}
                    fontWeight="700"
                    variant="h6"
                    color="white"
                    align="center"
                  >
                    Amplifying Expertise, Elevating Care
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={4.6}>
              <Box
                sx={{
                  backgroundColor: "#FFFFFF",
                  padding: 4,
                  borderRadius: "32px",
                  // width: '530px',
                }}
              >
                {children}
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* </Container> */}
      </Box>
    </React.Fragment>
  );
};
